// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctas{column-gap:0.25rem}@media (max-width: 767.98px){.ctas{flex-direction:column}}\n", ""]);
// Exports
module.exports = exports;
